import React from 'react';

export default {
    routes: [
        {
            exact: true,
            path: '/verification/slider-verification',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "BrowserInWechat",webpackPrefetch: true */ '@/pages/verification/slider-verification'),
            ),
        },
        {
            exact: true,
            path: '/news/news-detail',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "NewsDetail",webpackPrefetch: true */ '@/pages/news/news-detail'),
            ),
        },
        {
            exact: true,
            path: '/announcement/announcement-detail',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "AnnouncementDetail",webpackPrefetch: true */ '@/pages/announcement/announcement-detail'),
            ),
        },
        {
            exact: true,
            path: '/announcement/message-detail',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "MessageDetail",webpackPrefetch: true */ '@/pages/announcement/message-detail'),
            ),
        },
        {
            exact: true,
            path: '/agreements/withdrawal-disclaimer',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "customerAgreements",webpackPrefetch: true */ '@/pages/agreements/withdrawal-disclaimer'),
            ),
        },
        {
            exact: true,
            path: '/trading-guide',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "TradingGuide",webpackPrefetch: true */ '@/pages/agreements/trading-guide'),
            ),
        },
        {
            exact: true,
            path: '/fee-description',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "FeeDescription",webpackPrefetch: true */ '@/pages/agreements/fee-description'),
            ),
        },
        {
            exact: true,
            path: '/about-vg',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "AboutVg",webpackPrefetch: true */ '@/pages/about-vg'),
            ),
        },
        {
            exact: true,
            path: '/agreements/customer-agreement',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "agreements",webpackPrefetch: true */ '@/pages/agreements-viewer'),
            ),
        },
        {
            exact: true,
            path: '/agreements/privacy-policy',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "agreements",webpackPrefetch: true */ '@/pages/agreements-viewer'),
            ),
        },
        {
            exact: true,
            path: '/agreements/risk-warning-notice',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "agreements",webpackPrefetch: true */ '@/pages/agreements-viewer'),
            ),
        },
        {
            exact: true,
            path: '/agreements/conflicts-of-interest-policy',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "agreements",webpackPrefetch: true */ '@/pages/agreements-viewer'),
            ),
        },
        {
            exact: true,
            path: '/agreements/aml-policy-fsca',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "agreements",webpackPrefetch: true */ '@/pages/agreements-viewer'),
            ),
        },
        {
            exact: true,
            path: '/agreements/risk-disclosure-statement',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "riskAgreements",webpackPrefetch: true */ '@/pages/agreements/risk-disclosure-statement'),
            ),
        },
        {
            exact: true,
            path: '/agreements/product-disclosure-statement',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "productAgreements",webpackPrefetch: true */ '@/pages/agreements/product-disclosure-statement'),
            ),
        },
        {
            exact: true,
            path: '/agreements/complaint-handling-policy',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "agreements",webpackPrefetch: true */ '@/pages/agreements-viewer'),
            ),
        },
        {
            exact: true,
            path: '/user-center/feature-feedback',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "featureUserCenter",webpackPrefetch: true */ '@/pages/user-center/feature-feedback'),
            ),
        },
        {
            exact: true,
            path: '/user-center/open-account',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "openUserCenter",webpackPrefetch: true */ '@/pages/user-center/open-account'),
            ),
        },
        {
            exact: true,
            path: '/product/market-trends',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "marketTrends",webpackPrefetch: true */ '@/pages/product/market-trends'),
            ),
        },
        {
            exact: true,
            path: '/product/market-instrument',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "marketInstrument",webpackPrefetch: true */ '@/pages/product/market-instrument'),
            ),
        },
        {
            exact: true,
            path: '/product/trading-panel',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "tradingPanel",webpackPrefetch: true */ '@/pages/product/trading-panel'),
            ),
        },
        {
            exact: true,
            path: '/user-center/account-cancellation',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "accountCancellation",webpackPrefetch: true */ '@/pages/user-center/account-cancellation'),
            ),
        },
        {
            exact: true,
            path: '/activity/new-customer',
            isDynamic: true,
            component: React.lazy(
                () => import( /* webpackChunkName: "newCustomerActivity",webpackPrefetch: true */ '@/pages/activity/new-customer-activity'),
            ),
        }
    ],
};
